import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const SEARCH = () => {
  return (
    <CardSection id="SEARCH" title="SEARCH">
      <Paragraph>
        지정된 문자열을 검색하여 문자열의 인덱스를 반환합니다. 찾을 수 없으면{" "}
        <Paragraph accent>-1</Paragraph> 값을 반환합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>SEARCH(VALUE, STRING)</Paragraph>
        <Ul>
          <Li>
            <b>VALUE</b>는 평가하려는 텍스트 또는 열입니다.
          </Li>
          <Li>
            <b>STRING</b>은 검색할 문자열입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>SEARCH(`product`, "g")</Paragraph>
        <Img src="computeSearch" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          <b>SEARCH</b>는 다음과 같이 결합될 수 있습니다.
        </Paragraph>
        <Paragraph accent>
          REPLACE(`Hospital Name`, Search(`Hospital Name`, "ADVOCATE"), 8,
          "ALPHA")
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
